export const PROPOSED_PICKUP_SELECTED = 'PROPOSED_PICKUP_SELECTED';
export const PROPOSED_PICKUP_SCHEDULED = 'PROPOSED_PICKUP_SCHEDULED';

export const proposedPickupScheduled = (data) => ({
  type: PROPOSED_PICKUP_SELECTED,
  data,
});

export const proposedPickupMethodSelected = (data) => ({
  type: PROPOSED_PICKUP_SCHEDULED,
  data,
});
